import React, {useState} from 'react';
import { Col, Row } from 'react-flexbox-grid';
import {PlusOutlined, CaretDownOutlined, MinusOutlined , SearchOutlined} from '@ant-design/icons';
import {Tabs, Input, Radio, DatePicker, Button, List, Select} from 'antd';
import moment from 'moment';
import active from "../../containers/Dashboard/Active";
import { getUser, getSelectedUser, addnewCommentFMPTracker} from '../../api';
import FmpAssetCommentsIcon from "../CommentsIcon/FmpAssetCommentsIcon";
import SeverityIcon from 'components/SeverityIcon/SeverityIcon';

const {TabPane} = Tabs;

const Accordion = ({
                    data = [], 
                    project, 
                    seAssets, 
                    pceAssets,
                    onRowExpand, 
                    onGroupExpand, 
                    activeTab, 
                    lcraStatus = [], 
                    onAddClick,
                    handleProjectDetailUpdate,
                    onDataRefreshed,
                    ... props
                  }) => {

  const T_NAME = 'Name';
  const [expandedGroups, setExpandedGroups] = useState({});
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedStatuses, setSelectedStatuses] = useState({});
  const [statusSelected, setStatusSelected] = useState(null)
  const isFMPTracker = activeTab === 'fmp-tracker';
  const isAsset = activeTab === 'asset';
  const [lcaRcaStatuses, setLcaRcaStatuses] = useState([]);
  const [addStatus, setAddStatus] = useState([]);
  const [futureSubmissionDate, setFutureSubmissionDate] = useState('');
  const [inputComments, setInputComments] = useState({});
  const [locationValue, setLocationValue] = useState(0);
  const [value, setValue] = useState('');
  const [comments, setComments] = useState([]);
  const [disable, setDisable] = useState(true);
  const [text, setText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({
      userId: '',
      firstName: '',
      lastName: '',
      displayName: '',
      cellNumber: '',
      company: '',
      email: '',
      role: '',
      phoneNumber: '',
    });
  const [validationErrors, setValidationErrors] = useState({
      role: null,
      duplicateUser: null,
      name: null,
  });
  const finalData = data;
  const caaStatusList = [
    {statusOrder: '0', status: 'Not Started'},
    {statusOrder: '1', status: 'In-Progress'},
    {statusOrder: '2', status: 'Off-Design Findings'},
    {statusOrder: '3', status: 'Engineering Under Review'},
    {statusOrder: '4', status: 'Engineering QA'},
    {statusOrder: '5', status: 'Received from Engineering'},
    {statusOrder: '6', status: 'Completed - As-Built'},
    {statusOrder: '7', status: 'Completed - No Changes Required'}
  ];
  const statusList = activeTab === 'fmp-tracker' ? lcraStatus : caaStatusList;
  const isStatusDisabled = (row) => {
    if (isAsset) {
      return !(row.lcaRcaStatus && row.lcaRcaStatus.includes('Completed')) && row.lcaRcaStatus !== 'N/A' || (getTrackStatus(row) !== null && getTrackStatus(row).includes('Completed'));
    }
    if(isFMPTracker){
      return (row.lcaRcaStatus && row.lcaRcaStatus === 'Completed - No FMPs' || row.lcaRcaStatus === 'N/A' || row.lcaRcaStatus === 'Completed - FMPs Submitted');
    }
    return true;
  }
  const isOptionDisabled = (option, row) => {
    if(isFMPTracker){
      return (((option.status === '1st Attempt' && row.attempts != null) || (option.status === 'New Attempt' && row.attempts == null)))
    }
    if(isAsset){

      return (((option.status !== 'Not Started'  && getTrackStatus(row) === null ) || (option.status === 'Not Started' && getTrackStatus(row) !== null) ))
    }
    return true;
    
  } 

   const getTrackSeverity = (row) => {
    switch (row.severity) {
      case "0": return 'None'
      case "1": return 'Minor'
      case "2": return 'Significant'
      case "3": return 'NEEDS REVIEWED'
      default: 'None'
    }
  }

  const renderCAADetails = (packageType, row) => {
    switch (packageType) {
      case 'Physical':
        return <div style={styles.ccaGridContainer}>
          <div style={styles.ccaLeftMargin}>Severity: {getTrackSeverity(row)}</div>
          <div>Asset Analyst SLA: {getSla(row)}</div>
          <div style={styles.ccaLeftMargin}>SE Engineer: {project.seNames}</div>
          <div>Engineering SLA: {getEngSla(row)}</div>
          <div style={styles.ccaLeftMargin}>SE Assets FMP
            Difference: {seAssets.filter(item => item.fmpDifference === 'Y').length}</div>
          <div>Total SLA: {row.physicalAssetsEngSLA + row.physicalAssetsSLA}</div>
          <div style={styles.ccaLeftMargin}>SE Assets IPS
            Difference: {seAssets.filter(item => item.ipsDifference === 'Y').length}</div>
          <div/>
          <div style={styles.ccaLeftMargin}>SE Assets Received: {seAssets.length}</div>
          <div/>
          <span style={styles.ccaLeftMargin}>Current Primary Recipient: {row.primaryRecipient}</span>
          <div/>
        </div>
      case 'ProtectionAndControl':
        return <div style={styles.ccaGridContainer}>
          <div style={styles.ccaLeftMargin}>Severity: {getTrackSeverity(row)}</div>
          <div>Asset Analyst SLA: {getSla(row)}</div>
          <div style={styles.ccaLeftMargin}>PCE Engineer: {project.pceNames}</div>
          <div>Engineering SLA: {getEngSla(row)}</div>
          <div style={styles.ccaLeftMargin}>PCE Assets FMP
            Difference: {pceAssets.filter(item => item.fmpDifference === 'Y').length}</div>
          <div>Total SLA: {row.pceAssetsEngSLA + row.pceAssetsSLA}</div>
          <div style={styles.ccaLeftMargin}>PCE Assets IPS
            Difference: {pceAssets.filter(item => item.ipsDifference === 'Y').length}</div>
          <div/>
          <div style={styles.ccaLeftMargin}>PCE Assets Received: {pceAssets.length}</div>
          <div/>
          <span style={styles.ccaLeftMargin}>Current Primary Recipient: {row.primaryRecipient}</span>
          <div/>
        </div>
      case 'OneLine':
        return <div style={styles.ccaGridContainer}>
          <div style={styles.ccaLeftMargin}>Severity: {getTrackSeverity(row)}</div>
          <div>Asset Analyst SLA: {getSla(row)}</div>
          <div style={styles.ccaLeftMargin}>SE Engineer: {project.seNames}</div>
          <div>Engineering SLA: {getEngSla(row)}</div>
          <div style={styles.ccaLeftMargin}>Location Changed:
            <Input
              style={styles.locChanged}           
              size='small'
              value={locationValue}
              onBlur={() => handleLocationChange(row)}
              onChange={setOnelineLocation}
            />
          </div>
          <div>Total SLA: {row.onelineAssetsEngSLA + row.onelineAssetsSLA}</div>
          <span style={styles.ccaLeftMargin}>Current Primary Recipient: {row.primaryRecipient}</span>
          <div/>
        </div>
    }
  }

  const getTrackStatus = (row) => {
    switch (row.packageType) {
      case 'Physical': return row.physicalAssetsStatus
      case 'ProtectionAndControl': return row.pceAssetsStatus
      case 'OneLine': return row.onelineAssetsStatus
    }
  }

  const getTrackStatusDate = (row) => {
    let statusDate = '';
    if(isFMPTracker){
       statusDate = moment.utc(row.lastModifiedDate).local().format('MMMM DD, YYYY HH:mm:ss') ;
    } else if (row.fieldName === 'PHYSICAL_ASSETS_STATUS') {
      statusDate = moment.utc(row.physicalChangedDate).local().format('MMMM DD, YYYY HH:mm:ss');
    } else if (row.fieldName === 'PCE_ASSETS_STATUS'){
      statusDate = moment.utc(row.pceChangedDate).local().format('MMMM DD, YYYY HH:mm:ss');
    } else if (row.fieldName === 'ONELINE_ASSETS_STATUS'){
      statusDate = moment.utc(row.onelineChangedDate).local().format('MMMM DD, YYYY HH:mm:ss');
    } else { statusDate }

    return statusDate;
  }


  const toggleGroup = (groupName) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName]
    }));

    if (onGroupExpand) {
      onGroupExpand(groupName, !expandedGroups[groupName]);
    }
  };

  const toggleRow = (rowId) => {
    setExpandedRows(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));

    if (onRowExpand) {
      setLcaRcaStatuses(lcraStatus);
      onRowExpand(rowId, !expandedRows[rowId]);
    }
  };
  const getRowStyle = (status) => {
    switch (status) {
      case 'Selected':
        return {
          backgroundColor: '#e6f7ff',
          borderLeft: '3px solid #1890ff'
        };
      case 'Closed':
        return {
          backgroundColor: '#f5f5f5',
          color: '#999',
          opacity: 0.7
        };
      default:
        return {
          backgroundColor: '#fff'
        };
    }
  };

let getEngSla = (row) => {
  let result = (row.packageType === 'Physical') ? row.physicalAssetsEngSLA :
               (row.packageType === 'OneLine') ? row.onelineAssetsEngSLA :
               (row.packageType === 'ProtectionAndControl') ? row.pceAssetsEngSLA :
               null;

  return result;
}

let getSla = (row) => {
  let result = (row.packageType === 'Physical') ? row.physicalAssetsSLA :
               (row.packageType === 'OneLine') ? row.onelineAssetsSLA :
               (row.packageType === 'ProtectionAndControl') ? row.pceAssetsSLA :
               null;

  return result;
}

const getComments = (data) => {
  let result = data.fmpTrackerComments.length < 1 ? '' : data.fmpTrackerComments[0]?.comments

  return result;
}

 const handleAddStatusAction = async (status,rowData) => {
    let dataName = (rowData.packageType == 'Physical' && !lcaRcaStatuses.some((rec) => rec.status === status)) ? "PHYSICAL_ASSETS_STATUS" :
               (rowData.packageType == 'OneLine' && !lcaRcaStatuses.some((rec) => rec.status === status)) ? "ONELINE_ASSETS_STATUS" :
               (rowData.packageType  == 'ProtectionAndControl' && !lcaRcaStatuses.some((rec) => rec.status === status)) ? "PCE_ASSETS_STATUS" :
               (lcaRcaStatuses.some((rec) => rec.status === status)) ? "LCA_RCA_STATUS" :
               null;
                  
    try{

        await handleProjectDetailUpdate(status,dataName,'string',rowData.fmpId,'A');

        if (futureSubmissionDate) {
            handleFutureSubmission(rowData.fmpId);
        }

        if(onDataRefreshed){
          onDataRefreshed();
        }
        rowData.newStatus = null;
        setStatusSelected(null)
        setAddStatus([])
        setFutureSubmissionDate(null);

    }catch (error){
      console.error('API ERROR here on Save: ', error);
    }
  };

  async function onTextChanged() {
      const value = text;
      let suggestions = [];
      if (value.length > 2) {
        //TODO: better loading state while searching names
        suggestions = [{ firstName: 'Please', lastName: 'Wait...' }];
        setSuggestions(suggestions);
        suggestions = await getUser(value);
  
        if (!suggestions) suggestions = [];
        setSuggestions(suggestions);
        validationError('name', value === T_NAME ? 1 : 0);
      }
  }

  async function addComment(rec, rowKey) {
      let groupType = (rec.packageType === 'Physical') ? 'PHYSICAL_COMMENTS' :
               (rec.packageType === 'OneLine') ? 'ONELINE_COMMENTS' :
               (rec.packageType === 'ProtectionAndControl') ? 'PCE_COMMENTS' :
               null;

      let commentRequest = {
          bpid: rec.bpid,
          workOrder: rec.workOrder,
          stationName: rec.stationName,
          commentGrp : groupType,
          comments: value,
          fmpId: rec.fmpId
      }
          
      let updatedComment = await addnewCommentFMPTracker(commentRequest, rec.bpid);
          setDisable(true);
          setComments(updatedComment);
          
        try{
          onDataRefreshed();
          setTimeout(() => {
            setInputComments(prev => {
                const newState = { ...prev };
                delete newState[rowKey];
                return newState;
            });
        }, 500);
        }catch(error){
          console.error(error)
        }  
          
  }

  const handleChange = event => {
        setValue(event.target.value);
        setDisable(false);
  };

const setOnelineLocation = (e) => {
    const { value } = e.target;
    const reg = /^-?[0-9]*(\.[0-9]*)?$/;
    if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
      setLocationValue(Number(value));
    }
}

const getOnelineLocChangeValue = (row, key) => {
  if(key.includes("OneLine")){
    setLocationValue(row.onelineLocChanged);
  }
  
}

  const handleLocationChange = async (row) => {
        if(locationValue) {
          await handleProjectDetailUpdate(locationValue,'ONELINE_LOC_CHANGED','number',row.fmpId);
          
         if(onDataRefreshed){
          onDataRefreshed();

        }
    };
  }


  const updateText = (e) => {
    let text = e.target.value;
    if (!text || text === '') {
      setUser({
        userId: '',
        firstName: '',
        lastName: '',
        displayName: '',
        cellNumber: '',
        company: '',
        email: '',
        role: '',
        phoneNumber: '',
      });
      setSuggestions([]);
    }
    setText(text);
  };

  async function suggestionSelected(value) {
      let newFirstName;
      let newLastName;
      //handling undefined value case incase
  
      if (value.displayName) {
        // to divide display in order to overwrite first and last Name
        let displayNameArray = value.displayName.split(' ');
        newFirstName = displayNameArray[0];
        newLastName = displayNameArray.slice(1).join(' ');
      } else {
        newFirstName = value.firstName;
        newLastName = value.lastName;
      }
  
      let selectedUser = await getSelectedUser(value.userId);
      let updatedUser = { ...value };
  
      if (selectedUser.user && selectedUser.user.userId) {
        if (selectedUser.user.cellNumber) {
          updatedUser = {
            ...value,
            ...{ cellNumber: selectedUser.user.cellNumber },
          };
        }
        if (selectedUser.user.phoneNumber) {
          updatedUser = {
            ...updatedUser,
            ...{ phoneNumber: selectedUser.user.phoneNumber },
          };
        }
      }
  
      // upending first and lastName for using display name so we can display according to display name
      updatedUser = {
        ...updatedUser,
        firstName: newFirstName,
        lastName: newLastName,
      };
  
      setUser(updatedUser);
      /* using updatedUser.firstName and updated.LastName instead of value.firstName and lastName because value still contain
  original value
  */
      setText(updatedUser.firstName + ' ' + updatedUser.lastName);
  
      setSuggestions([]);
    }

    const updatePrimaryRecepient = async (text,rowId) => {
      await handleProjectDetailUpdate(
                                          text,
                                          'PRIMARY_RECIPIENT',
                                          'string',
                                          rowId
                                        );
         if(onDataRefreshed){
          onDataRefreshed();
        }
    }

  const handleFutureSubmission = async (id) => {
    try{
        await handleProjectDetailUpdate(moment(futureSubmissionDate).format('MMMM DD, YYYY'),'ETA_SUBMISSION','date',id);
         if(onDataRefreshed){
          onDataRefreshed();
         }        

    }catch (error){
      console.error('API ERROR here on Save: ', error);
    }
  };

    function renderSuggestions() {
      if (suggestions.length === 0) {
        return <div />;
      }
      return (
        <List className='list-style'>
          {suggestions.map((suggestion, index) => (
            <List.Item
              style={{ cursor: 'pointer' }}
              className='list-item'
              onClick={() => suggestionSelected(suggestion)}
            >
              {suggestion.displayName ? (
                <>
                  {suggestion.displayName} {suggestion.userId}
                </>
              ) : (
                <>
                  {suggestion.firstName}
                  {'   '}
                  {suggestion.lastName} {suggestion.userId}
                </>
              )}
            </List.Item>
          ))}
        </List>
      );
    }


   function validationError(type, value) {
    setValidationErrors((prevState) => {
      const nextState = { ...prevState };
      nextState[type] = value;
      return nextState;
    });
  }

  function filterStatusHistory(lcaRcaStatusHistory) {
    let filterHistoryArray =[];

    if(lcaRcaStatusHistory){
      const removeOldFutureSubmitRecords = lcaRcaStatusHistory.filter(item => item.status !== 'Future Submission');
      const lastFutureSubmitRecord = lcaRcaStatusHistory.filter(item => item.status  === 'Future Submission').slice(0,1);
      filterHistoryArray = [...lastFutureSubmitRecord,...removeOldFutureSubmitRecords];

      const uniqueElements = new Set(filterHistoryArray);
      const duplicates = [];

      filterHistoryArray.forEach(item => {
        const itemIdentifier = item["lastModifiedDate"]; 

        if (uniqueElements.has(itemIdentifier)) {
          duplicates.push(item);
        } else {
          uniqueElements.add(itemIdentifier);
        }
        
      });
    
      const dupeIds = duplicates.map(id => id.auditId);
      
      filterHistoryArray = filterHistoryArray.filter(obj => !dupeIds.includes(obj.auditId));

      filterHistoryArray = filterHistoryArray.toSorted((a, b) => {
        const dateA = new Date(a.lastModifiedDate);
        const dateB = new Date(b.lastModifiedDate);
        return dateB - dateA; 
      });
    }

   return filterHistoryArray;
}


  const styles = {
    container: {
      width: '100%',
      fontFamily: 'Arial, sans-serif'
    },
    tabsContainer: {
      marginBottom: '0'
    },
    tableContainer: {
      width: '100%',
      border: '1px solid #e8e8e8',
      borderTop: 'none',
      borderRadius: '0 0 4px 4px',
      overflow: 'hidden'
    },
    groupHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 16px',
      backgroundColor: '#f0f0f0',
      border: '2px solid rgb(0, 0, 0)',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      color: '#262626'
    },
    groupExpandIcon: {
      fontSize: '14px',
      color: '#595959',
      transition: 'transform 0.2s ease',
      marginRight: '8px',
      userSelect: 'none'
    },
    groupTitle: {
      flex: 1,
      display: 'flex',
      marginRight:'8px'
    },
    groupSeverity: {
      flex: 16,
      display: 'flex'
    },
     locChanged: {
      width:'75px'
    },
    groupCount: {
      color: '#595959',
      fontSize: '14px'
    },
    headerRow: {
      display: 'flex',
      backgroundColor: '#fafafa',
      borderBottom: '1px solid #e8e8e8',
      fontWeight: '500',
      fontSize: '12px',
      color: '#595959',
      paddingLeft: '40px'
    },
    headerCell: {
      padding: '8px 16px',
      borderRight: '1px solid #e8e8e8',
      flex: 1,
      textAlign: 'left'
    },
    expandColumn: {
      width: '40px',
      flexShrink: 0
    },
    dataRow: {
      display: 'flex',
      borderBottom: '1px solid #f0f0f0',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      minHeight: '40px',
      alignItems: 'center'
    },
    dataCell: {
      padding: '8px 16px',
      borderRight: '1px solid #f0f0f0',
      flex: 1,
      fontSize: '13px',
      color: '#262626'
    },
    expandCell: {
      width: '40px',
      flexShrink: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px'
    },
    expandIcon: {
      fontSize: '14px',
      color: '#595959',
      transition: 'transform 0.2s ease',
      cursor: 'pointer',
      userSelect: 'none'
    },
    expandedContent: {
      padding: '16px',
      backgroundColor: '#f9f9f9',
      borderTop: '1px solid #e8e8e8',
      fontSize: '13px',
      color: '#595959',
      marginLeft: '40px'
    },
    closedText: {
      marginLeft: '8px',
      fontStyle: 'italic',
      color: '#999'
    },
    // DS Track Section Styles
    sectionTitle: {
      fontWeight: '500',
      marginBottom: '12px',
      color: '#262626'
    },
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '16px',
      marginBottom: '8px'
    },
    topInputLabel: {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      minWidth: '120px'
    },
    inputWithMargin: {
      marginTop: '4px'
    },
    manualBox: {
      fontSize: '12px',
      maxWidth: '50px',
      maxHeight: '20px'
    },
    datePickerStyle: {
      width: '100%',
      marginTop: '4px'
    },
    // CCA Section Styles
    ccaGridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      fontWeight: 'bold',
      marginBottom: '60px'
    },
    ccaLeftMargin: {
      gridColumn: 'span 3'
    },
    // Status Table Styles
    statusRow: {
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns: '1fr 1fr 1fr',
      margin: '20px 0px 40px'
    },
    statusCell: {
    },
    statusLabel: {
      display: 'inline',
      textAlign: 'left',
      fontWeight: 'bold'
    },
    statusSelectBox: {
      margin: '0 0 0 10px',
      minWidth: '300px',
      fontSize: '12px'
    },
    statusAddButton: {
      padding: '2px 16px 4px',
      fontSize: '12px',
      border: '1px solid #d9d9d9',
      borderRadius: '2px',
      cursor: 'pointer',
      height: '24px', 
      display: (addStatus === "Future Submission" && (futureSubmissionDate === "" || futureSubmissionDate === null)) ? 'none' : 'inline'
    },
    statusTable: {
      border: '1px solid #e8e8e8',
      borderRadius: '2px',
      overflow: 'hidden'
    },
    statusTableHeader: {
      display: 'grid',
      backgroundColor: '#fafafa',
      borderBottom: '1px solid #e8e8e8',
      padding: '8px',
      fontSize: '12px',
      fontWeight: '500',
      color: '#595959'
    },
    statusTableRow: {
      display: 'grid',
      padding: '8px',
      fontSize: '12px',
      color: '#595959'
    },
    // Primary Recipient Section Styles
    recipientSection: {
      marginTop: '30px',
      marginBottom: '20px'
    },
    recipientInputRow: {
      display: 'grid',
      gridTemplateColumns: '2fr 2fr',
      padding: '8px',
      fontSize: '12px',
      color: '#595959'
    },
    recipientList: {
      border: '1px solid #e8e8e8',
      borderRadius: '2px',
      overflow: 'hidden'
    },
    recipientItem: {
      padding: '8px',
      fontSize: '12px',
      color: '#595959'
    },
    // Comments Section Styles
    commentsSection: {
      marginTop: '30px',
      marginBottom: '20px'
    },
    commentsLabel: {
      fontWeight: '500',
      marginBottom: '8px',
      color: '#262626'
    },
    textArea: {
      resize: 'none',
      backgroundColor: '#fff'
    },
    datePicker:{
      width: '300px',
      marginLeft: '60px',
    },
    placeholderText: {
        color: '#bfbfbf', 
        fontStyle: 'italic',
    },
    defaultText: {
        color: '#000000',
        fontStyle: 'normal',
    },
  };

  const handleCommentChange = (e, key) => {
    setInputComments(prev => ({
        ...prev,
        [key]: e.target.value
    }));
    handleChange(e); 
  };

  const groupedProjectDetails = finalData && finalData.fmpProjectDetails
    ? finalData.fmpProjectDetails.reduce((acc, item) => {
        const type = item.packageType;
        if (type) {
            if (!acc[type]) {
                acc[type] = [];
            }
            acc[type].push(item);
        }
        return acc;
    }, {})
    : {};


  return (
    <div style={styles.container}>
      <div style={styles.tableContainer}>


        {Object.keys(groupedProjectDetails).map((packageType) => {

          const groupArray = groupedProjectDetails[packageType];
          const group = groupArray
          const isGroupExpanded = expandedGroups[packageType] !== false;
          let finalRowList = [];

          if (isAsset) {
            let assetHistoryList = [];

            switch (packageType) {
              case 'ProtectionAndControl':
                group.map(item => assetHistoryList.push({fmpId: item.fmpId, filterArray: item.pceAssetsHistory || []}))
                assetHistoryList;
                break;
              case 'Physical':
                group.map(item => assetHistoryList.push({fmpId: item.fmpId, filterArray: item.physicalAssetsHistory || []}))
                assetHistoryList ;
                break;
              case 'OneLine':
                group.map(item => assetHistoryList.push({fmpId: item.fmpId, filterArray: item.oneLineAssetsHistory || []}))
                assetHistoryList;
                break;
              default:
                assetHistoryList = [];
            }

            finalRowList = assetHistoryList || [];
            Array.isArray(finalRowList[0].filterArray) ? finalRowList : finalRowList = [];

          } else {
            let lcaRcaHistoryList = [];
            group.map(item => lcaRcaHistoryList.push({fmpId: item.fmpId, filterArray: filterStatusHistory(item.lcaRcaStatusHistory) || []}))
            const trackerSourceList = lcaRcaHistoryList || [];
            finalRowList = trackerSourceList;
          }
          finalRowList = finalRowList || [];

          if (group) {
            return (
              <div key={packageType}>
                <div
                  style={styles.groupHeader}
                  onClick={() => toggleGroup(packageType)}
                >
                      <span
                        style={{
                          ...styles.groupExpandIcon,
                          transform: isGroupExpanded ? 'rotate(0deg)' : 'rotate(270deg)'
                        }}
                      >
                        <CaretDownOutlined/>
                      </span>
                  <span style={styles.groupTitle}>{packageType}</span>
                  <span style={styles.groupSeverity}>{groupArray.some(item => item.severity === "2" | item.severity === "3") ? <SeverityIcon /> : null}</span>
                  {isFMPTracker && (<span style={styles.groupCount}>{group.count}</span>)}
                </div>
                {isGroupExpanded && (
                  <div>
                    {groupArray.map((row, rowIndex) => {
                      const rowKey = row.auditId || packageType + rowIndex;                    
                      const currentDisplayValue = inputComments[rowKey] ?? getComments(row);
                      const hasUserTyped = inputComments.hasOwnProperty(rowKey); 
                      const dynamicStyle = hasUserTyped ? styles.defaultText : styles.placeholderText;
                      const isRowExpanded = expandedRows[rowKey];
                      const rowStyle = getRowStyle(row.status);
                      const statusTableGrid = isFMPTracker ? '2fr 2fr 2fr 1fr' : '3fr 3fr 2fr';
                      const commentGroup =
                        row.packageType === 'Physical' ? "PHYSICAL_COMMENTS" :
                        row.packageType === 'OneLine' ? "ONELINE_COMMENTS" :
                        row.packageType === 'ProtectionAndControl' ? "PCE_COMMENTS" :
                        null;
                      const setNewStatus = (status, rowKey) => {
                          row.status = status;
                          setAddStatus(status);
                          setStatusSelected(status)
                          setSelectedStatuses(prev => ({
                          ...prev,
                          [rowKey]: status
                        }));
                      }
                      return (
                        <div key={rowKey}>
                          <div
                            style={{...styles.dataRow, ...rowStyle}}
                            onClick={() =>{ 
                              toggleRow(rowKey);
                              getOnelineLocChangeValue(row,rowKey);
                            }}
                            onMouseEnter={(e) => {
                              if (row.status === 'Normal') {
                                e.currentTarget.style.backgroundColor = '#f5f5f5';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (row.status === 'Normal') {
                                e.currentTarget.style.backgroundColor = rowStyle.backgroundColor;
                              }
                            }}
                          >
                            <div style={styles.expandCell}>
                              <span style={styles.expandIcon}>
                                    {isRowExpanded ? <MinusOutlined/> : <PlusOutlined/>}
                              </span>
                            </div>
                            <div style={styles.dataCell}>ID: {row.fmpId}</div>
                            <div style={styles.dataCell}>DS Track Status: {row.dstrackStatus}</div>
                            <div style={styles.dataCell}>Created Date: {moment.utc(row.fmpCreatedDate).local().format('MMMM DD, YYYY')}</div>
                            {isAsset && (<div style={styles.dataCell}>State: {row.dstrackState}</div>)}
                            {isFMPTracker && (
                              <div style={styles.dataCell}>RCA/LCA
                                Status: {row.lcaRcaStatus}  </div>)}
                          </div>
                          {isRowExpanded && (
                            <div style={styles.expandedContent}>

                              {isFMPTracker && (<div>
                                <div style={styles.sectionTitle}>DS Track:</div>
                                <div style={styles.gridContainer}>
                                  <div>
                                    <label style={styles.topInputLabel}>State: {row.dstrackState}</label>
                                  </div>
                                  <div>
                                    <label style={styles.topInputLabel}>Status: {row.dstrackStatus}</label>
                                  </div>
                                  <div>
                                    <label style={styles.topInputLabel}>Created date: {moment.utc(row.fmpCreatedDate).local().format('MMMM DD, YYYY')}</label>
                                  </div>
                                </div>
                              </div>)}

                              {/* CAA Track Details */}
                              {isAsset && <FmpAssetCommentsIcon
                                project={project}
                                fmpId={row.fmpId}
                                commentGroup={commentGroup}
                                view={'dashboard'}
                                comments={[]}
                                phase={0}
                                />}
                              {isAsset && (
                                renderCAADetails(packageType, row)
                              )}
                              <div style={styles.statusRow}>
                                <div style={styles.statusCell}>

                                  <label style={styles.statusLabel}>Status: </label>
                                  <Select
                                    size="large"
                                    disabled={isStatusDisabled(row)}
                                    placeholder="Select Status"
                                    style={styles.statusSelectBox}
                                    value={row.newStatus}
                                     onChange={(value) => setNewStatus(value, rowKey)}

                                  >
                                    
                                    {[...statusList]
                                      .sort((a, b) => Number(a.statusOrder) - Number(b.statusOrder))
                                      .map(option => (
                                        <Option key={option.statusOrder} value={option.status} disabled={isOptionDisabled(option, row)}>
                                          {option.status}
                                        </Option>
                                      ))}
                                  </Select>
                                  
                                    {selectedStatuses[rowKey] === 'Future Submission' && (
                                              <DatePicker
                                                autoComplete="off"
                                                format={'MMMM DD, YYYY'}
                                                size="small"
                                                allowClear={false}
                                                style={styles.datePicker}
                                                placeholder="Select Date"
                                                onChange={(dateString) => setFutureSubmissionDate(dateString)}
                                            />
                                            )}
                                  <Button style={styles.statusAddButton}
                                          disabled={isStatusDisabled(row)}
                                          onClick={() => {handleAddStatusAction(addStatus,row); setSelectedStatuses([])}}>Add</Button>
                                </div>
                                <div style={styles.statusCell}>
                                  <label style={styles.statusLabel}>Current Status: {isFMPTracker ? row.lcaRcaStatus : getTrackStatus(row)}</label>
                                </div>
                                 <div style={styles.statusCell}>
                                  {isFMPTracker ? <label style={styles.statusLabel}>Attempts: {row.attempts} </label>: null}
                                </div>
                              </div>

                              <div>
                                <div>
                                  <div style={styles.statusTable}>
                                    <div style={{...styles.statusTableHeader, gridTemplateColumns: statusTableGrid}}>
                                      <div>STATUS</div>
                                      <div>USER NAME</div>
                                      <div>STATUS DATE</div>
                                      {isFMPTracker && (<div>ETA</div>)}
                                    </div>
                                    {Array.isArray(finalRowList) && finalRowList
                                    .filter(item => item.fmpId == row.fmpId)
                                    .map((historyRecord, idx) => (
                                      <div
                                        key={idx}
                                        style={{
                                          ...styles.statusTableRow,
                                          gridTemplateColumns: statusTableGrid,
                                          borderBottom: idx < 3 ? '1px solid #f0f0f0' : 'none',
                                          backgroundColor: idx % 2 === 1 ? '#fafafa' : '#fff'
                                        }}
                                      >
                                        {historyRecord.filterArray.map(filterRecord =>(
                                        <>
                                          <div>{filterRecord.status}</div>
                                          <div>{filterRecord.lastModifiedBy}</div>
                                          <div>{getTrackStatusDate(filterRecord)}</div>
                                          {isFMPTracker && (<div>{filterRecord.status === 'Future Submission' ? moment(row.etaSubmission).format('MMMM DD, YYYY') : moment(filterRecord.lastModifiedDaten).add(14, 'days').format('MMMM DD, YYYY')}</div>)}
                                        </>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                </div>

                            {/* Primary Recipient Section */}
                            {isFMPTracker && (<div style={styles.recipientSection}>
                              <div style={styles.rcaInputRow}>
                                <div style={styles.flexOne}>
                                  <div style={styles.sectionTitle}>DS Track Primary Recipient: {row.fmpTrackerTracksRecipients[0] ? row.fmpTrackerTracksRecipients.at(-1).originalRecipient : row.primaryRecipient}</div>
                                  <div style={styles.sectionTitle}>Current Primary Recipient: {row.fmpTrackerTracksRecipients[0] ? row.primaryRecipient : null}</div>
                                  <div className='row align-items-center'>
                                  <Row>
                                  <Col xs={24} md={{ span: 12, offset: 6,}} style={{paddingLeft: '30px'}}>
                                  <Input
                                      autoComplete='off'
                                      type='text'
                                      value={text}
                                      style={{width: '400px'}}
                                      onChange={updateText}
                                      id='searchPrimary'
                                      allowClear
                                      placeholder='Search Primary Recipient'
                                      prefix={
                                        <SearchOutlined
                                          id='search-icon'
                                          style={{ marginRight: 8, padding: 0 }}
                                        />
                                      }
                                    />
                                    <span className='stationNameDropdown'>
                                      {suggestions && suggestions.length > 0 && renderSuggestions()}
                                    </span>
                                    </Col>
                                    <Col xs={12} md={{ span: 6, offset: 6, }}>
                                    <button
                                      type='button'
                                      className='btn btn-primary btn-block'
                                      style={{ marginBottom: '14px', width: '100px' }}
                                      disabled={text === null || text === '' ? true : false}
                                      onClick={onTextChanged}
                                    >
                                      Search
                                    </button>
                                    </Col>
                                    <Col xs={12} md={{ span: 6, offset: 6, }}>
                                    <button
                                      type='button'
                                      className='btn btn-primary btn-block'
                                      style={{ marginBottom: '14px', width: '100px' }}
                                      disabled={text === null || text === '' ? true : false}
                                      onClick={() => {
                                         updatePrimaryRecepient( text,
                                          row.fmpId)
                                         }}
                                    >
                                      Add
                                    </button>
                                    </Col>
                                    </Row>
                                    </div>
                            </div>
                                <div style={styles.flexOne}>
                                </div>
                              </div>
                              {/* Previous Recipients List */}
                              <div style={styles.statusTable}>
                                <div style={{...styles.statusTableHeader,
                                  gridTemplateColumns: '2fr 2fr 2fr 1fr'
                                }}>
                                  <div>RECIPIENT</div>
                                  <div>CHANGE DATE</div>
                                </div>      
                              <div style={styles.recipientList}>
                                {row.fmpTrackerTracksRecipients && row.fmpTrackerTracksRecipients.map((rec,idx) => (
                                  <div
                                    key={idx}
                                     style={{
                                          ...styles.statusTableRow,
                                          borderBottom: idx < 3 ? '1px solid #f0f0f0' : 'none',
                                          backgroundColor: idx % 2 === 1 ? '#fafafa' : '#fff',
                                          gridTemplateColumns: '2fr 2fr 2fr 1fr'
                                        }}
                                  >
                                    <div>{rec.primaryRecipient}</div>
                                    <div>{moment(rec.auditCreatedDate).format('MMMM DD, YYYY HH:mm:ss')}</div>
                                  </div>
                                ))}
                              </div>
                               </div>
                            </div>)}

                                {/* Comment Section */}
                                {isFMPTracker &&
                                  <div style={styles.commentsSection}>
                                    <div style={styles.commentsLabel}>Comments:</div>
                                    <Input.TextArea
                                      rows={4}
                                      value={currentDisplayValue} 
                                      style={{...styles.textArea, ...dynamicStyle}} 
                                      onChange={(e) => handleCommentChange(e, rowKey)}
                                    />
                                    <button
                                        type='button'
                                        className='btn btn-primary btn-block'
                                        style={{ marginBottom: '14px', width: '100px' }}
                                        disabled={value === null || value === '' ? true : false}
                                        onClick={() => addComment(row, rowKey)}
                                      >
                                        Add
                                      </button>
                                  </div>
                                }
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
};


export default Accordion;